const GET_HELP_UPLOAD_MAX_FILE_SIZE_MB = 5;

export {
    GET_HELP_UPLOAD_MAX_FILE_SIZE_MB,
}